  <template>
  <v-app id="adpics">
    <v-app-bar
      app
      clipped-left
      color="secondary"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <h3 class>ADPICS</h3>
      </v-toolbar-title>
      <v-spacer></v-spacer>
        {{ currentTime }}
      <v-spacer></v-spacer>
      <v-btn icon>
        {{ getUnresolvedAlertTotal }} 
        <v-icon>fa-bell</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>fa-power-off</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list color="primary">
          <v-list-item>
              <v-list-item-avatar>
                  <v-icon>fa-user</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                  {{ login.user }}
              </v-list-item-content>
              <v-btn icon small>
                  <v-icon>fa-sign-in-alt</v-icon>
              </v-btn>
          </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <v-list>
        <v-list-item v-for="ele in views" :key="ele.title" :to="ele.href">
             <v-list-item-icon>
                <v-icon>{{ ele.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ ele.title }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <router-view
            v-bind:currentTime="currentTime" 
            v-bind:networkDetails="networkDetails"
            v-bind:sensorType="sensorType"
            v-bind:environmentInfo="environmentInfo"
            v-bind:baselineInfo="baselineInfo"
            v-bind:alertsData="alertsData"
            v-bind:alertsSchema="alertsSchema"
            @updateEnvironmentInfo="updateEnvironmentInfo"
            @updateBaselineInfo="updateBaselineInfo"
          ></router-view>
        </v-row>
      </v-container>
    </v-main>


    <v-footer app color="secondary">
      <span>Attila Cybertech &copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
  import * as d3 from "d3";
  import _ from "lodash";
  import Chance from "chance";

  export default {
    data: () => ({
      drawer: null,
      views: [
        { title:"Dashboard Overview", href:"/", icon:"fa-chart-bar" },
        { title:"Asset Discovery", href:"/assetDiscovery", icon:"fa-tools" },
        { title:"Alert Monitor", href:"/alertMonitor", icon:"fa-bell" },
        { title:"AI Models", href:"/aiModels", icon:"fa-brain" },
        { title:"Settings", href:"/settings", icon:"fa-cogs" },
        { title:"About", href:"/about", icon:"fa-question-circle" }
      ],
      login: {
        user: "Tan Wei Kong"        
      },
      currentTime: "Loading...",
      networkDetails: {
        name: "CBX-732",
        networkSnapshot: "Current live network",
        baselineSnapshot: "Current live network",
        snapshot : [
          {
            links: "data/sample-links-v1.json",
            nodes: "data/sample-nodes-v1.json",
            timestamp: new Date(2020, 3, 17, 3, 24, 0)
          },
          {
            links: "data/sample-links-v2.json",
            nodes: "data/sample-nodes-v2.json",
            timestamp: new Date(2020, 5, 21, 7, 15, 0)
          },
          {
            links: "data/sample-links-v3.json",
            nodes: "data/sample-nodes-v3.json",
            timestamp: new Date(2020, 6, 11, 19, 55, 0)
          },
          {
            links: "data/sample-links-v3.json",
            nodes: "data/sample-nodes-v3.json",
            timestamp:"Current live network"
          }
        ]
      },
      sensorType: [
        { type: "human machine interface", image: "img/HMI.svg"},
        { type: "plant control interface", image: "img/PCN.svg"},
        { type: "engineering workstation", image: "img/EWS.svg"},
        { type: "access point", image: "img/AP.svg"},
        { type: "server", image: "img/Server.svg"},
        { type: "firewall", image: "img/Firewall.svg"},
        { type: "sensor", image: "img/Sensor.svg"},
        { type: "actuator", image: "img/Actuator.svg"},
        { type: "network switch", image: "img/Switch.svg"},
        { type: "network attached storage", image: "img/Switch.svg"},
        { type: "plant control network", image: "img/PCN.svg"},
        { type: "human control interface", image: "img/HMI.svg"}
      ],
      environmentInfo: {},
      baselineInfo: {},
      alertsData: [],
      alertsSchema: {
        statusType: ["resolved", "unresolved"],
        severityType: ["low", "moderate", "severe"],
        alertType: ["new node", "disconnected","threshold error", "sensor failure"]
      }
    }),
    computed: {
      getUnresolvedAlertTotal: function() {
        return this.alertsData.filter(ele => ele.resolved == "unresolved").length;
      }
    },
    methods: {
      getCurrentTime: function() {
        let now = new Date();
        let format = d3.timeFormat("%B %d, %Y %H:%M:%S");
        this.currentTime = format(now);
      },
      updateEnvironmentInfo: function(data){
          this.environmentInfo = data;
      },
      updateBaselineInfo: function(data){
          this.baselineInfo = data;
      },
      loadCurrentEnvironment: function() {
        //Store Vue environment!
        let that = this;

        //Loads environmentInfo and baselineInfo to be the latest
        let ele = this.networkDetails.snapshot[this.networkDetails.snapshot.length - 1];

        d3.json(ele.nodes).then(data => {
          that.environmentInfo = _.countBy(data.node, function(ele2) { return ele2.type });
          that.baselineInfo = _.countBy(data.node, function(ele2) { return ele2.type });
        })
      },
      createRandomAlerts(size) {
        const chance = new Chance();

        for (let i=0; i < size; i++) {
          let obj = {};
          obj.sourceIp = chance.ip();
          obj.destIp = chance.ip();
          obj.severity = chance.pickone(this.alertsSchema.severityType);
          obj.nodename = chance.word() + chance.integer({ min: 0, max: 20 });
          obj.alertType = chance.pickone(this.alertsSchema.alertType);
          obj.timestamp = chance.date({year: 2020});
          obj.resolved = ( i < size - 10) ? "resolved" : "unresolved";
          obj.report = (obj.resolved == "resolved") ?
           { engineer: "Tan Wei Kong", comment:"Checked and rectified", timeRectified: new Date()} :
           { engineer: "", comment: "", timeRectified: null}

          this.alertsData.push(obj);
        }
      }
    },
    created: function() {
      this.$vuetify.theme.dark = false;
    },
    mounted: function() {
      setInterval(() => {this.getCurrentTime()}, 1000)
      this.loadCurrentEnvironment();
      this.createRandomAlerts(50);
    }
  }
</script>